import { createBrowserRouter } from 'react-router-dom'
import { Layout } from '@/components'
import { Home } from '@/pages/home'
import { Informacoes } from '@/pages/informacoes'
import { Historico } from '@/pages/historico'
import { Pagamento } from '@/pages/pagamento'
import { Pedidos } from '@/pages/pedidos'
import { Rastreio } from '@/pages/rastreio'
import { Formulario } from '@/pages/formulario'
import { EditarCampos } from '@/pages/editarCampos'
import { Campos } from '@/pages/campos/Campos'
import { Sucesso } from '@/pages/sucesso'

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/editar-campos',
    element: <EditarCampos />,
  },
  {
    path: '/modal',
    element: <Layout />,
    children: [
      { index: true, element: <Informacoes /> },
      { path: 'historico', element: <Historico /> },
      { path: 'pagamento', element: <Pagamento /> },
      { path: 'pedidos', element: <Pedidos /> },
      { path: 'rastreio', element: <Rastreio /> },
      { path: 'formulario', element: <Formulario /> },
      { path: 'campos', element: <Campos /> },
      { path: 'sucesso', element: <Sucesso /> },
    ],
  },
])
